
import React, { useEffect, useState } from 'react'
import { CommonPageHeading } from '../../../CommonUtils/CommonHeading/CommonPageHeading';
import * as jnb from 'react-bootstrap';
import { config } from '../../../CommonUtils/CommonUrl/CommonUrls';
import {  CommonAxiosPost } from '../../../CommonUtils/CommonAxios/CommonAxios';
import Header from '../../../Header/Header';
import { useLocation } from 'react-router-dom';
import { ApprovalReportData } from './ApprovalReportData';

export default function InwardDaywiseDashboard() {
  
  const location = useLocation()
    const data = location?.state
    const [showList, setList] = useState([]);

    function GetChequeInReport() {
        let values = {
            "incharge_cfms_id": data?.data?.incharge_cfms_id,
            "inward_date_from": data?.fromDate,
            "inward_date_upto": data?.todate,  
        }
        let url = config.url.BOC_URL + "inward-dashboard-data";
        CommonAxiosPost(url, values).then((res) => {
            if (res?.data?.status === true) {
                console.log("filtereddaata",res?.data?.inward_dashboard_data?.filter((val)=>val.payment_status===data?.status))
                setList(res?.data?.inward_dashboard_data?.filter((val)=>val.payment_status===data?.status))
            }
        }
        )
    }
    useEffect(() => {
        GetChequeInReport()
    }, [])

    return (
        <React.Fragment>
            <Header />
            <div className="main_section"> </div>
            <CommonPageHeading heading="Inward Dashboard" navigateData={data} path="/InwardDashboard" />
            <jnb.Container className="outer-page-content-container">
                        <div className="table-responsive">
                        <ApprovalReportData showList={showList} />
                        {/* {data?.status==="P"?
                        <ApprovalPaymentConfirm showList={showList} data={data} />:
                        <ApprovalReportData showList={showList} />} */}
                        </div>
                                    
                   
            </jnb.Container>




        </React.Fragment>
    )
}
